<template>
	<div class="pageContainer app-container studentContainer">
		<el-row>
			<el-select v-model="searchForm.ktype" size="small" placeholder="请选择" style="width: 150px;">

				<el-option label="学生姓名" value="stu_name">学生姓名</el-option>
				<el-option label="考试证号" value="exam_num">考试证号</el-option>
			</el-select>


			<el-input v-model="searchForm.keyword" size="small" placeholder="请输入查询关键字"
				style="max-width: 200px;margin-right: 10px; margin-left: 10px;" />
			<span style="font-size: 14px;">分数修改：</span>
			<el-select v-model="searchForm.sp_status" size="small" placeholder="请选择"
				style="width: 100px; margin-right: 10px;">

				<el-option label="全部" value="">全部</el-option>
				<el-option label="待审核" :value="0">待审核</el-option>
				<el-option label="审核通过" :value="1">审核通过</el-option>
				<el-option label="审核不通过" :value="-1">审核不通过</el-option>
			</el-select>
			<span style="font-size: 14px;">专业：</span>
			<el-select v-model="searchForm.major_id" size="small" placeholder="请选择"
				style="width: 150px; margin-right: 10px;">

				<el-option label="全部" value="">全部</el-option>
				<el-option v-for="(d,i) in majorList" :key="i" :label="d.title" :value="d.id"></el-option>

			</el-select>
			<span style="font-size: 14px;">性别：</span>
			<el-select v-model="searchForm.gender" size="small" placeholder="请选择"
				style="width: 80px; margin-right: 10px;">

				<el-option label="全部" value="">全部</el-option>
				<el-option label="男" :value="1">男</el-option>
				<el-option label="女" :value="2">女</el-option>

			</el-select>


			<el-button size="small" icon="el-icon-search" @click="getList" plain type="primary">查询</el-button>

			<el-button size="small" icon="el-icon-printer" @click="downXls" plain type="primary">导出XLS</el-button>
			<el-button size="small" icon="el-icon-printer" @click="getAllData" plain type="primary">打印登分表</el-button>
			<el-button size="small" icon="el-icon-printer" @click="getBmData" plain type="primary">打印报名册</el-button>
			<el-button size="small" icon="el-icon-printer" @click="getGDData" plain type="primary">打印高低分册</el-button>
			<el-button size="small" icon="el-icon-printer" @click="getZKZData" plain type="primary">打印准考证号</el-button>

		</el-row>
		<el-row type="flex" :gutter="16" style="margin-top: 20px">

			<el-col :span="24" class="tabContainer">
				<el-tabs v-model="activeName" type="card" style="">
					<el-tab-pane v-for="item in tabMapOptions" :key="item.key" :label="item.label" :name="item.key">

					</el-tab-pane>


				</el-tabs>



				<el-table stripe :data="tableData" style="width: 100%;margin-bottom: 20px; color: #000;" border
					size="mini" @sort-change="resortData">
					<el-table-column type="index" width="55" label="序号">
					</el-table-column>

					<el-table-column prop="exam_num" width="100" sortable label="准考证号">
						<template slot-scope="scope">
							{{ scope.row.exam_num_refee||scope.row.exam_num }}
						</template>
					</el-table-column>
					<el-table-column prop="stu_name" label="姓名" width="80">
						<template slot-scope="scope">

							<span style="color: lightgreen;" title="分数审核已通过"
								v-if="scope.row.sp_status>=1">{{scope.row.stu_name}}</span>
							<span style="color: orangered;" title="已提交分数修改,还未审核"
								v-else-if="scope.row.sp_status===0">{{scope.row.stu_name}}</span>
							<span style="color: orchid;" :title="scope.row.sp_word"
								v-else-if="scope.row.sp_status===-1">
								{{scope.row.stu_name}}
								<el-tooltip class="item" effect="dark" :content="scope.row.sp_word" placement="top-end">
									<i class="el-icon-warning"></i>
								</el-tooltip>
							</span>
							<span v-else>{{scope.row.stu_name}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="gender" label="性别" sortable width="80">
						<template slot-scope="scope">

							<span v-if="scope.row.gender==1">男</span>
							<span v-if="scope.row.gender==2">女</span>

							<span v-if="scope.row.gender==0">未知</span>
						</template>
					</el-table-column>

					<el-table-column prop="gender" label="专业" min-width="120">
						<template slot-scope="scope">

							<span>
								<strong style="color: orangered;" v-if="scope.row.major_type=='主'">
									[{{scope.row.major_type}}]
								</strong>
								<strong style="color:dodgerblue;" v-if="scope.row.major_type=='兼'">
									[{{scope.row.major_type}}]
								</strong>
								{{scope.row.major_name}}</span>
							<span>{{scope.row.item_desc}}</span>

						</template>
					</el-table-column>


					<el-table-column prop="exam_score" label="专业1/素描分" min-width="60">
						<template slot-scope="scope">
							<span v-if="scope.row.pjson">{{scope.row.pjson.zhuan1}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="exam_score" label="专业2/色彩分" min-width="60">
						<template slot-scope="scope">
							<span v-if="scope.row.pjson">{{scope.row.pjson.zhuan2}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="exam_score" label="专业3" min-width="60">
						<template slot-scope="scope">
							<span v-if="scope.row.pjson">{{scope.row.pjson.zhuan3}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="exam_score" label="专业4" min-width="60">
						<template slot-scope="scope">
							<span v-if="scope.row.pjson">{{scope.row.pjson.zhuan4}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="exam_score" label="专业5" min-width="60">
						<template slot-scope="scope">
							<span v-if="scope.row.pjson">{{scope.row.pjson.zhuan5}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="exam_score" label="视唱1" min-width="60">
						<template slot-scope="scope">
							<span v-if="scope.row.pjson">{{scope.row.pjson.zhuan6}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="exam_score" label="视唱2" min-width="60">
						<template slot-scope="scope">
							<span v-if="scope.row.pjson">{{scope.row.pjson.zhuan7}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="exam_score" label="视唱3" min-width="60">
						<template slot-scope="scope">
							<span v-if="scope.row.pjson">{{scope.row.pjson.zhuan8}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="exam_score" label="视唱4" min-width="60">
						<template slot-scope="scope">
							<span v-if="scope.row.pjson">{{scope.row.pjson.zhuan9}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="exam_score" label="视唱5" min-width="60">
						<template slot-scope="scope">
							<span v-if="scope.row.pjson">{{scope.row.pjson.zhuan10}}</span>
						</template>
					</el-table-column>



					<el-table-column prop="total_score" label="总分" sortable min-width="60">
						<template slot-scope="scope">

							<span>{{scope.row.total_score|xs2wei}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="pjson" label="状态" min-width="60">
						<template slot-scope="scope">

							<span v-if="scope.row.sp_status===0" style="color:#0000FE;cursor: pointer;"
								@click="showModitfyScore(scope.row)">审核</span>

							<span v-if="scope.row.sp_status===-1" style="color:orchid;">审核不通过</span>
							<span v-if="scope.row.sp_status===1" style="color:lightgreen;">审核通过</span>
						</template>
					</el-table-column>


				</el-table>
				<el-pagination @current-change="handlePageChange" :current-page="page.pageIndex"
					:page-size="page.pageSize" :total="page.total" @size-change="handleSizeChange"
					:page-sizes="page.pageSizes" layout="total, prev, pager, next, sizes, jumper">
				</el-pagination>


			</el-col>
		</el-row>


		<!-- <feePrint v-if="showPrint" :stuid="editOptions.id"></feePrint> -->

		<el-dialog title="成绩修改审核" width="800px" :visible.sync="editScoreShow" :close-on-click-modal="false">
			<el-form :model="editPjson" inline label-width="120px" v-if="editScoreShow">
				<div style="text-align: center; font-size: 20px; margin-bottom: 20px;">
					{{editPjson.stu_name}}【{{editPjson.exam_num}}】
				</div>
				<el-row :gutter="20">

					<el-col :span="12">
						<el-form-item label="专业1/素描分" prop="exam_num">
							{{editPjson.old_pjson.zhuan1}} <span
								style="color: orangered; margin-right: 10px;">=></span>{{editPjson.new_pjson.zhuan1}}
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="专业2/色彩分" prop="exam_num">
							{{editPjson.old_pjson.zhuan2}} <span
								style="color: orangered; margin-right: 10px;">=></span>{{editPjson.new_pjson.zhuan2}}
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="专业3" prop="exam_num">
							{{editPjson.old_pjson.zhuan3}} <span
								style="color: orangered; margin-right: 10px;">=></span>{{editPjson.new_pjson.zhuan3}}
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="专业4" prop="exam_num">
							{{editPjson.old_pjson.zhuan4}} <span
								style="color: orangered; margin-right: 10px;">=></span>{{editPjson.new_pjson.zhuan4}}
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="专业5" prop="exam_num">
							{{editPjson.old_pjson.zhuan5}} <span
								style="color: orangered; margin-right: 10px;">=></span>{{editPjson.new_pjson.zhuan5}}
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="20">

					<el-col :span="12">
						<el-form-item label="专业6" prop="exam_num">
							{{editPjson.old_pjson.zhuan6}} <span
								style="color: orangered; margin-right: 10px;">=></span>{{editPjson.new_pjson.zhuan6}}
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="专业7" prop="exam_num">
							{{editPjson.old_pjson.zhuan7}} <span
								style="color: orangered; margin-right: 10px;">=></span>{{editPjson.new_pjson.zhuan7}}
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="专业8" prop="exam_num">
							{{editPjson.old_pjson.zhuan8}} <span
								style="color: orangered; margin-right: 10px;">=></span>{{editPjson.new_pjson.zhuan8}}
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="专业9" prop="exam_num">
							{{editPjson.old_pjson.zhuan9}} <span
								style="color: orangered; margin-right: 10px;">=></span>{{editPjson.new_pjson.zhuan9}}
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="专业10" prop="exam_num">
							{{editPjson.old_pjson.zhuan10}} <span
								style="color: orangered; margin-right: 10px;">=></span>{{editPjson.new_pjson.zhuan10}}
						</el-form-item>
					</el-col>
				</el-row>


			</el-form>
			<div style="text-align: left">
				<el-input v-model="sp_word" type="text" placeholder="请输入审核不通过的原因..."
					style="width: 60%; margin-right: 20px;"></el-input>
				<el-button icon="el-icon-check" type="primary" @click="saveScoreUpd(1)">审核通过</el-button>
				<el-button icon="el-icon-close" type="warning" @click="saveScoreUpd(-1)">审核拒绝</el-button>
			</div>

		</el-dialog>



		<el-dialog title="打印成绩表(红色为兼报)" width="1000px" :visible.sync="printShow" :close-on-click-modal="false">

			<div style="text-align: right; position: absolute; top:20px; right: 100px;">
				<el-button v-print="'#printMe'" icon="el-icon-printer" @click="changePrint(1)" type="primary">打印
				</el-button>
			</div>
			<div id="printMe" style="width: 800px; margin: 0 auto;" v-if="printShow">
				<div :id="'table'+idx" v-for="(major,idx) in tableDataPrint" :key="idx" style=" vertical-align: top;"
					v-if="major.students.length>0">


					<div style="text-align: center; font-size: 18px; text-align: center;padding-bottom: 20px;">
						江苏省戏剧学校{{year}}年招生专业成绩登分表
					</div>
					<div>
						报考专业： {{major.name}}
					</div>
					<table class="dtable">
						<thead>
							<tr style="margin-top: 10px;" v-if="major.name.indexOf('艺术设计')>=0">
								<th>序号</th>
								<th>准考证号</th>
								<th>姓名</th>
								<th>性别</th>
								<th>素描分</th>
								<th>色彩分</th>
								<th>专业总分</th>
							</tr>
							<tr style="margin-top: 10px;" v-if="major.name.indexOf('音乐表演')>=0">
								<th>序号</th>
								<th>准考证号</th>
								<th>姓名</th>
								<th>性别</th>
								<th>专业分</th>
								<th>视唱练耳</th>
								<th>专业总分</th>
							</tr>
							<tr style="margin-top: 10px;"
								v-if="major.name.indexOf('戏剧')>=0||major.name.indexOf('舞蹈')>=0">
								<th>序号</th>
								<th>准考证号</th>
								<th>姓名</th>
								<th>性别</th>
								<th>专业总分</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(stu,i) in major.students" :key="i" v-if="major.name.indexOf('艺术设计')>=0"
								:class="stu.major_type=='兼'?'jian':''">
								<td>{{i+1}}</td>
								<td>{{stu.exam_num}}</td>
								<td>{{stu.stu_name}}</td>
								<td><span v-if="stu.gender==1">男</span>
									<span v-if="stu.gender==2">女</span>

									<span v-if="stu.gender==0">未知</span>
								</td>

								<td>{{stu.pjson?(stu.pjson.zhuan1):''}}</td>
								<td>{{stu.pjson?(stu.pjson.zhuan2):''}}</td>

								<td>{{stu.total_score|xs2wei}}</td>
							</tr>
							<tr v-for="(stu,i) in major.students" :key="i" v-if="major.name.indexOf('音乐表演')>=0"
								:class="stu.major_type=='兼'?'jian':''">
								<td>{{i+1}}</td>
								<td>{{stu.exam_num}}</td>
								<td>{{stu.stu_name}}</td>
								<td><span v-if="stu.gender==1">男</span>
									<span v-if="stu.gender==2">女</span>

									<span v-if="stu.gender==0">未知</span>
								</td>

								<td>{{stu.wh_score}}
								</td>
								<td>{{stu.zy_score}}
								</td>

								<td>{{stu.total_score|xs2wei}}</td>
							</tr>
							<tr v-for="(stu,i) in major.students" :key="i"
								v-if="major.name.indexOf('戏剧')>=0||major.name.indexOf('舞蹈')>=0"
								:class="stu.major_type=='兼'?'jian':''">
								<td>{{i+1}}</td>
								<td>{{stu.exam_num}}</td>
								<td>{{stu.stu_name}}</td>
								<td><span v-if="stu.gender==1">男</span>
									<span v-if="stu.gender==2">女</span>

									<span v-if="stu.gender==0">未知</span>
								</td>

								<td>{{stu.total_score|xs2wei}}</td>
							</tr>
						</tbody>

					</table>
					<div style=" padding-top: 20px;">
						登分人员： <span
							style="display: inline-block; border-bottom: 1px solid #000; text-align: center; width: 180px;">&nbsp;{{major.teacher}}</span>
						日期：<span
							style="display: inline-block; border-bottom: 1px solid #000; text-align: center;  width: 180px;">&nbsp;{{major.udate}}</span>
						校领导：<span
							style="display: inline-block; border-bottom: 1px solid #000; text-align: center; text-decoration: underline; width: 180px;">&nbsp;</span>
					</div>
					<div :id="'blank_'+idx" style=" "></div>

				</div>


			</div>
		</el-dialog>


		<el-dialog title="打印招生报名册" width="1000px" :visible.sync="printBmcShow" :close-on-click-modal="false">

			<div style="text-align: right; position: absolute; top:20px; right: 100px;">
				<el-button v-print="'#printMe'" icon="el-icon-printer" @click="changePrint(1)" type="primary">打印
				</el-button>
			</div>
			<div id="printMe" style="width: 800px; margin: 0 auto;" v-if="printBmcShow">
				<div style=" vertical-align: top;">


					<div style="text-align: center; font-size: 18px; text-align: center;padding-bottom: 30px;">
						江苏省戏剧学校{{digit2Zhcn(year)}}年招生报名册
					</div>

					<table class="dtable">
						<thead>
							<tr style="margin-top: 10px;">
								<th>序号</th>
								<th>专业名称</th>
								<th>准考证号</th>
								<th>姓名</th>
								<th>性别</th>
								<th>毕业学校</th>

							</tr>

						</thead>
						<tbody>
							<tr v-for="(stu,i) in tableDataPrint" :key="i">
								<td>{{i+1}}</td>
								<td><strong style="color: orangered;" v-if="stu.major_type=='主'">
										[{{stu.major_type}}]
									</strong>
									<strong style="color:dodgerblue;" v-if="stu.major_type=='兼'">
										[{{stu.major_type}}]
									</strong>{{stu.major_name}}
								</td>
								<td>{{stu.exam_num_refee||stu.exam_num}}</td>
								<td>{{stu.stu_name}}</td>
								<td><span v-if="stu.gender==1">男</span>
									<span v-if="stu.gender==2">女</span>

									<span v-if="stu.gender==0">未知</span>
								</td>
								<td>{{stu.graduate_schname}}</td>
							</tr>

						</tbody>

					</table>


				</div>


			</div>
		</el-dialog>


		<el-dialog title="打印高低分册(红色为兼报)" width="1000px" :visible.sync="printRankShow" :close-on-click-modal="false">

			<div style="text-align: right; position: absolute; top:20px; right: 100px;">
				<el-button v-print="'#printMe'" icon="el-icon-printer" @click="changePrint(1)" type="primary">打印
				</el-button>
			</div>
			<div id="printMe" style="width: 800px; margin: 0 auto;" v-if="printRankShow">
				<div :id="'table'+idx" v-for="(major,idx) in tableDataPrint" :key="idx" style=" vertical-align: top; "
					v-if="major.students.length>0">


					<!-- <div style="text-align: center; font-size: 18px; text-align: center; padding-bottom: 20px;">
						{{digit2Zhcn(year)}}年江苏省戏剧学校专业考试成绩高低分册
					</div>
					<div>
						报考专业： {{major.name}}
					</div> -->
					<table class="dtable">
						<thead>
							<tr style="margin-top: 10px;font-size: 18px;">
								<th  colspan="8">{{digit2Zhcn(year)}}年江苏省戏剧学校专业考试成绩高低分册</th>
								
							</tr>
							<tr style="margin-top: 10px;">
								<th  colspan="8" style="text-align: left;">报考专业： {{major.name}}</th>
								
							</tr>
							<tr style="margin-top: 10px;">
								<th style="width: 50px;">序号</th>
								<th style="width: 66px;">准考证号</th>
								<th style="width: 70px;">姓名</th>
								<th style="width: 40px;">性别</th>
								<th style="width: 70px;">考生来源</th>
								<th>毕业学校</th>
								<th style="width: 70px;">专业总分</th>
								<th style="width: 120px;">备注</th>
							</tr>

						</thead>
						<tbody>
							<tr v-for="(stu,i) in major.students" :key="i" :class="stu.major_type=='兼'?'jian':''">
								<td>{{i+1}}</td>
								<td>{{stu.exam_num_refee||stu.exam_num}}</td>
								<td>{{stu.stu_name}}</td>
								<td><span v-if="stu.gender==1">男</span>
									<span v-if="stu.gender==2">女</span>
									<span v-if="stu.gender==0">未知</span>
								</td>
								<td>
									<span v-if="stu.ly_type==1">应届生</span>
									<span v-else>其他</span>
								</td>
								<td>{{stu.graduate_schname}}</td>

								<td>{{stu.total_score|xs2wei}}</td>
								<td>{{stu.remark}}</td>
							</tr>

						</tbody>

					</table>

					<div :id="'blank_'+idx" style=" "></div>

				</div>


			</div>
		</el-dialog>


		<el-dialog title="打印准考证号码" width="1000px" :visible.sync="printZkzShow" :close-on-click-modal="false">

			<div style="text-align: right; position: absolute; top:20px; right: 100px;">

				性别：<el-select v-model="searchForm.gender" size="small" placeholder="请选择"
					style="width: 80px; margin-right: 10px;">

					<el-option label="全部" value="">全部</el-option>
					<el-option label="男" :value="1">男</el-option>
					<el-option label="女" :value="2">女</el-option>

				</el-select>
				最低分:
				<el-input v-model="searchForm.score" size="small" type="number" placeholder="请输入分数"
					style="max-width: 200px;margin-right: 10px; margin-left: 10px;" />
				<el-button icon="el-icon-search" size="small" @click="getZKZData()" type="primary">查看
				</el-button>

				<el-button v-print="'#printMe'" size="small" icon="el-icon-printer" @click="changePrint(1)"
					type="primary">打印准考证号
				</el-button>
			</div>

			<div style="width: 800px; margin: 0 auto;" v-if="printZkzShow">
				<div style=" vertical-align: top;">


					<div style="text-align: center; font-size: 18px; text-align: center; padding-bottom: 20px;">
						{{digit2Zhcn(year)}}年江苏省戏剧学校舞蹈专业准考证号打印
					</div>

					<table class="dtable">
						<thead>
							<tr style="margin-top: 10px;">
								<th>序号</th>
								<th>准考证号</th>
								<th>姓名</th>
								<th>性别</th>
								<th>专业</th>
								<th>总分</th>

							</tr>

						</thead>
						<tbody>
							<tr v-for="(stu,i) in tableDataPrint" :key="i">
								<td>{{i+1}}</td>
								<td>{{stu.exam_num_wlt}}</td>
								<td>{{stu.stu_name}}</td>
								<td><span v-if="stu.gender==1">男</span>
									<span v-if="stu.gender==2">女</span>

									<span v-if="stu.gender==0">未知</span>
								</td>

								<td>
									{{stu.major_name}}
								</td>

								<td>{{stu.total_score}}</td>
							</tr>

						</tbody>

					</table>


				</div>


			</div>

			<div id="printMe" style="width: 800px; margin: 0 auto;" v-if="printZkzShow">
				<div style="width: 49%; height: 200px; line-height: 200px; font-size: 60px; text-align: center; color: #000; display: inline-block;  vertical-align: top; border: 1px solid #000;"
					v-for="(stu,idx) in tableDataPrint" :key="idx">{{stu.exam_num}}</div>
			</div>
		</el-dialog>

	</div>
</template>
<script>
	import api from '@/api/api';

	export default {
		name: 'Student',
		components: {

		},
		data() {
			return {
				searchForm: {
					ktype: 'stu_name',
					orderby: " exam_num asc",
					sp_status: "",
					gender: "",
					score: "",
					major_id: ""
				}, //查询
				sp_word: "",
				modalTitle: '添加学生',
				showStu: false,
				showPrint: false,
				scoreshow: false,
				printShow: false,
				printBmcShow: false,
				printRankShow: false,
				printZkzShow: false,
				viewType: "",
				//tree
				treeData: [],
				treeProps: {
					children: 'children',
					label: 'title'
				},
				treeData1: [],
				treeProps1: {
					children: 'children',
					label: 'title',
					value: 'id',
					checkStrictly: true,
					emitPath: false,
				},

				//table
				tabMapOptions: [{
						label: '学生列表',
						key: 'notsp'
					},

				],
				activeName: 'notsp',
				tableData: [],
				tableDataPrint: [],
				page: {
					pageIndex: 1,
					pageSize: 20,
					pageSizes: [10, 20, 50],
					total: 0
				},
				multipleSelection: [],
				deptId: null,
				editOptions: {},
				teacherId: null,
				majorList: [],
				areaList: [],
				pmid: 1,
				st0Count: 0,
				editPjson: {},
				editScoreShow: false,
				year: localStorage.getItem("year")
			}
		},

		filters: {
			xs2wei(n) {
				let m = String(n);
				if (m.length > 0) {
					if (m.indexOf(".") > 0) {
						let zheng = m.split(".")[0]
						let fen = m.split(".")[1]
						if (fen.length == 1) {
							fen = fen + "0"
						} else if (fen.length >= 2) {
							fen = fen.substr(0, 2)
						} else if (fen.length == 2) {
							if (fen[1] >= 5) {
								let num = parseInt(fen)
								num += 1;
								if (num == 100) {
									zheng = parseInt(zheng) + 1;
									fen = "00"
								} else {
									fen = num
								}
							}
						}
						return zheng + "." + fen
					} else {
						return m + ".00"
					}
				} else {
					return "0.00"
				}

			}

		},

		mounted() {
			this.getList();
			this.getMajors()

			this.$nextTick(() => {

				$("#btnxlsbox").width($(window).width() - 500)
			})






		},
		methods: {
			changePrint(type) {
				let html = '';
				type = type ? type : 1;

				// if (type == '1') {
				// 	html = '<style type="text/css" media="print">\n' + '  @page { size: landscape; }\n' + '</style>';
				// } else {
				// 	html = '<style type="text/css" media="print">\n' + '  @page { size: portrait; }\n' + '</style>';
				// }
				html = '<style type="text/css" media="print">\n' + '  @page { size: portrait; margin:20px }\n' +
					'</style>';
				$('#printMe').append(html);

			},
			showModitfyScore(row) {

				this.editPjson = JSON.parse(JSON.stringify(row))
				this.editScoreShow = true
			},

			getMajors() {

				this.$http.post("/api/sch_major_list").then(res => {
					this.majorList = res.data[0].children
				})
			},


			//table
			getList() {
				// this.tableData = []
				let params = {
					page: this.page.pageIndex,
					pagesize: this.page.pageSize,
					sp_status: this.searchForm.sp_status,
					major_id: this.searchForm.major_id,
					gender: this.searchForm.gender

				}

				params.ktype = this.searchForm.ktype
				params.keyword = this.searchForm.keyword
				if (this.searchForm.orderby && this.searchForm.orderby.indexOf("gender") >= 0) {
					params.orderby = this.searchForm.orderby + " ,total_score desc "
				} else {
					params.orderby = this.searchForm.orderby
				}
				this.$http.post("/api/xjxy_score_students", params).then(res => {
					for (let item of res.data.data) {
						if (item.pjson) {
							item.pjson = JSON.parse(item.pjson)
						}
						if (item.old_pjson) {
							item.old_pjson = JSON.parse(item.old_pjson)
						}
						if (item.new_pjson) {
							item.new_pjson = JSON.parse(item.new_pjson)
						}
					}
					this.tableData = res.data.data
					this.page.total = res.data.page.count
					//this.st0Count = res.data.st0.st0
				})
			},
			getAllData() {
				//this.tableData = []
				let params = {
					page: this.page.pageIndex,
					pagesize: this.page.pageSize,
					sp_status: this.searchForm.sp_status,
					major_id: this.searchForm.major_id,
					gender: this.searchForm.gender,
					print: 1

				}

				params.ktype = this.searchForm.ktype
				params.keyword = this.searchForm.keyword
				if (this.searchForm.orderby && this.searchForm.orderby.indexOf("gender") >= 0) {
					params.orderby = this.searchForm.orderby + " ,total_score desc "
				} else {
					params.orderby = this.searchForm.orderby
				}
				this.$http.post("/api/xjxy_score_students", params).then(res => {
					let majorDic = JSON.parse(JSON.stringify(this.majorList))
					for (let m of majorDic) {
						m.name = m.title
						m.teacher = "";
						m.udate = "";
						m.students = [];
					}

					for (let item of res.data) {
						if (item.total_score) {
							if (item.pjson) {
								item.pjson = JSON.parse(item.pjson)
							}
							for (let m of majorDic) {
								if (m.name.indexOf(item.major_name) >= 0 || item.major_name.indexOf(m.name) >= 0) {
									if (m.teacher != item.username) {
										m.teacher = item.username
									}

									m.udate = item.udate;
									m.students.push(item)
								}
							}
						}
					}

					this.tableDataPrint = majorDic
					this.printShow = true
					this.$nextTick(() => {
						
						
						for (let i = 0; i < majorDic.length; i++) {
							if (majorDic[i].students.length > 0) {
								try {
									let h1 = $("#table" + i).height()
								
									let pages = Math.ceil(h1 / 1016)
									$("#blank_" + i).height(1016 - h1 % 1016)
								} catch (e) {
									//TODO handle the exception
								}
							}

						}


					})
				})


			},
			getBmData() {
				//this.tableData = []
				let params = {
					page: this.page.pageIndex,
					pagesize: this.page.pageSize,
					sp_status: this.searchForm.sp_status,
					major_id: this.searchForm.major_id,
					gender: this.searchForm.gender,
					print: 1

				}

				params.ktype = this.searchForm.ktype
				params.keyword = this.searchForm.keyword
				if (this.searchForm.orderby && this.searchForm.orderby.indexOf("gender") >= 0) {
					params.orderby = this.searchForm.orderby + " ,total_score desc "
				} else {
					params.orderby = this.searchForm.orderby
				}
				this.$http.post("/api/xjxy_score_students", params).then(res => {

					for (let item of res.data) {
						if (item.total_score) {
							if (item.pjson) {
								item.pjson = JSON.parse(item.pjson)
							}

						}
					}

					this.tableDataPrint = res.data
					this.printBmcShow = true

				})
			},
			getGDData() {
				let params = {
					page: this.page.pageIndex,
					pagesize: this.page.pageSize,
					sp_status: this.searchForm.sp_status,
					major_id: this.searchForm.major_id,
					gender: this.searchForm.gender,
					print: 1

				}

				params.ktype = this.searchForm.ktype
				params.keyword = this.searchForm.keyword
				if (this.searchForm.orderby && this.searchForm.orderby.indexOf("gender") >= 0) {
					params.orderby = this.searchForm.orderby + " ,total_score desc "
				} else {
					params.orderby = " total_score desc"
				}

				this.$http.post("/api/xjxy_score_students", params).then(res => {
					let majorDic = JSON.parse(JSON.stringify(this.majorList))
					for (let m of majorDic) {
						m.name = m.title
						m.teacher = "";
						m.udate = "";
						m.students = [];
					}

					for (let item of res.data) {
						if (item.total_score) {
							if (item.pjson) {
								item.pjson = JSON.parse(item.pjson)
							}
							for (let m of majorDic) {
								if (m.name.indexOf(item.major_name) >= 0 || item.major_name.indexOf(m.name) >= 0) {
									if (m.teacher != item.username) {
										m.teacher = item.username
									}

									m.udate = item.udate;
									m.students.push(item)
								}
							}
						}
					}

					this.tableDataPrint = majorDic
					this.printRankShow = true
					this.$nextTick(() => {
					
						for (let i = 0; i < majorDic.length; i++) {
							let extRow = 0
							for(let stu of majorDic[i].students){
								if(stu.graduate_schname.length>18||stu.remark.length>6){
									extRow++
								}
							}
							console.log("extRow",extRow)
							if (majorDic[i].students.length > 0) {
								try {
									let leftcout = majorDic[i].students.length%38
									console.log("#blank_" + i, leftcout,extRow, 1014 - (leftcout-extRow*3)*28)
									$("#blank_" + i).height(1014 - (leftcout+extRow)*28)
								
								} catch (e) {
									//TODO handle the exception
								}
							}

						}


					})
				})

			},
			getZKZData() {



				let params = {
					page: this.page.pageIndex,
					pagesize: this.page.pageSize,
					sp_status: this.searchForm.sp_status,
					major_id: this.searchForm.major_id,
					gender: this.searchForm.gender,
					print: 1,
					score: this.searchForm.score

				}
				for (let m of this.majorList) {
					if (m.title.indexOf("舞蹈") >= 0) {
						params.major_id = m.id
					}
				}

				this.searchForm.orderby = " gender asc "

				params.ktype = this.searchForm.ktype
				params.keyword = this.searchForm.keyword
				if (this.searchForm.orderby && this.searchForm.orderby.indexOf("gender") >= 0) {
					params.orderby = this.searchForm.orderby + " ,total_score desc "
				} else {
					params.orderby = " total_score desc"
				}

				this.$http.post("/api/xjxx_wlt_stuexamecode", params).then(res => {
					this.$http.post("/api/xjxy_score_students", params).then(res => {
						for (let item of res.data) {
							if (item.pjson) {
								item.pjson = JSON.parse(item.pjson)
							}
						}
						this.tableDataPrint = res.data
						this.printZkzShow = true

					})
				})


			},
			resortData(e) {

				this.searchForm.orderby = e.prop + " " + (e.order == "ascending" ? 'asc' : 'desc')

				this.getList()
			},
			handlePageChange(e) {
				this.page.pageIndex = e
				this.getList()
			},
			handleSizeChange(e) {
				this.page.pageSize = e
				this.getList()
			},

			saveScoreUpd(st) {
				this.$confirm(st == 1 ? '确认修改成绩？' : '确认拒绝？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.post("/api/xjxx_stu_score_change_sp", {
						id: this.editPjson.change_id,
						sp_word: this.sp_word,
						sp_status: st
					}).then(res => {
						this.$message.success("保存成功！")
						this.editScoreShow = false
						this.getList();
					})

				}).catch(() => {

				});



			},
			downXls() {
				let params = {
					page: this.page.pageIndex,
					pagesize: this.page.pageSize,
					sp_status: this.searchForm.sp_status,
					major_id: this.searchForm.major_id,
					gender: this.searchForm.gender

				}
				this.$http.post("/api/xjxx_stu_score_xls", params).then(res => {
					if (res.data.url) {
						window.open(res.data.url, "_blank")
					}
				})
			}

		}
	}
</script>

<style lang="less" type="text/less">
	.studentContainer{
    .el-tabs__nav{
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .el-tabs__item{
        line-height: unset;
        display: flex;
        align-items: center;
    }
    .el-tabs__item.is-disabled {
        color: #303133;
        cursor:default
    }
    .el-tabs__item.is-active {
        color: #409EFF;
    }
	.jian{ color: orangered; td{ color: orangered;}}
}

</style>
<style scoped lang="less" type="text/less">
	.app-container {
  .treeContainer {
    height: 100%;
    background-color: #fff;
    box-shadow: 0 2px 4px 0 rgba(0,0,0,.12), 0 0 6px 0 rgba(0,0,0,.04);
    border: 1px solid  rgba(220,223,230,0.6);

    .treeTitle {
      height: 40px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      color: #409eff;
      padding-left: 6px;
    }
  }
}
</style>
